"use strict";
export const isInSameSudoSwapPool = (assetA, assetB) => {
  if (!assetA.sellorders || !assetB.sellorders) {
    return false;
  }
  const assetASudoSwapPoolParameters = assetA.sellorders[0].protocolParameters;
  const assetBSudoSwapPoolParameters = assetB.sellorders[0].protocolParameters;
  const assetAPoolAddress = assetASudoSwapPoolParameters?.poolAddress ? assetASudoSwapPoolParameters.poolAddress : void 0;
  const assetBPoolAddress = assetBSudoSwapPoolParameters?.poolAddress ? assetBSudoSwapPoolParameters.poolAddress : void 0;
  if (!assetAPoolAddress || !assetBPoolAddress) {
    return false;
  }
  if (assetAPoolAddress !== assetBPoolAddress) {
    return false;
  }
  return true;
};
export const isInSameMarketplaceCollection = (assetA, assetB) => {
  return assetA.address === assetB.address && assetA.marketplace === assetB.marketplace;
};
